module.exports = __webpack_public_path__ + "img/circle1.6aaad569.svg";